<template>
  <header>
    <div class="container">
      <div class="header-row">
        <a class="logo"></a>
        <span>
          Zapłać on-line za kod doładowania przedpłatowego licznika energii <sup>(1)</sup>
        </span>
      </div>
    </div>
  </header>
</template>
<script>
export default {
  name: 'Header'
}
</script>

<style lang="scss" src="../assets/scss/header.scss" scoped></style>
